import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Breadcrumb from '../../components/layout/Breadcrumb'
import { useAuth } from '../../providers/AuthProvider'
import { supabase } from '../../supabaseClient'
import { SUBJECTS, SUBJECT_META } from '../../data/standards'

const GRADES = [4, 5, 6, 7, 8]

export default function ProfilePage() {
  const navigate = useNavigate()
  const { profile, refreshProfile } = useAuth()
  const [name, setName] = useState(profile?.name || '')
  const [grade, setGrade] = useState(profile?.primary_grade || 5)
  const [subject, setSubject] = useState<string>(profile?.subject || 'Math')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleSave = async () => {
    if (!profile) return
    setSaving(true)
    await supabase
      .from('profiles')
      .update({ name, primary_grade: grade, subject, updated_at: new Date().toISOString() })
      .eq('id', profile.id)
    await refreshProfile()
    setSaving(false)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  if (!profile)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress size={24} />
      </Box>
    )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', bgcolor: 'background.default' }}>
      <Breadcrumb label="Back" onBack={() => navigate(-1)} />

      <Box sx={{ flex: 1, p: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ fontSize: 17, fontWeight: 800, color: 'primary.main' }}>
            Profile
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Role: <strong>{profile.role.charAt(0).toUpperCase() + profile.role.slice(1)}</strong>
          </Typography>
        </Box>

        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Display Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              size="small"
            />
            <FormControl size="small" fullWidth>
              <InputLabel>Primary Subject</InputLabel>
              <Select value={subject} label="Primary Subject" onChange={(e) => setSubject(e.target.value)}>
                {SUBJECTS.map((s) => (
                  <MenuItem key={s} value={s}>
                    {SUBJECT_META[s].icon} {s}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" fullWidth>
              <InputLabel>Primary Grade</InputLabel>
              <Select value={grade} label="Primary Grade" onChange={(e) => setGrade(Number(e.target.value))}>
                {GRADES.map((g) => (
                  <MenuItem key={g} value={g}>
                    Grade {g}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </CardContent>
        </Card>

        {saved && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Saved
          </Alert>
        )}

        <Button variant="contained" fullWidth onClick={handleSave} disabled={saving}>
          {saving ? <CircularProgress size={18} color="inherit" /> : 'Save Changes'}
        </Button>
      </Box>
    </Box>
  )
}
